<p-card class="p-card container">
  <h3 i18n>Recommandations</h3>
  @for (
    recommendation of recommendationsForm.controls;
    track recommendation;
    let i = $index;
    let first = $first
  ) {
    <form [formGroup]="recommendation">
      <div class="layout__inner-card margin--bottom-medium">
        <div class="layout--gap margin--bottom-medium">
          <div class="layout--full-width">
            <label class="label-top" i18n>Compagnie</label>
            <p-dropdown
              [options]="companyOptions | emTranslate"
              i18n-placeholder
              placeholder="Choisir"
              [formControl]="recommendation.controls.company"
              id="company"
              optionLabel="label"
              optionValue="value"></p-dropdown>
          </div>
        </div>
        <div class="layout__inner-card margin--bottom-medium">
          @for (
            product of recommendation.controls.products.controls;
            track product;
            let j = $index;
            let first = $first
          ) {
            <form [formGroup]="product">
              <h4 i18n>Produit {{ j + 1 }}</h4>
              <div class="layout--gap margin--bottom-medium">
                <div class="layout--full-width">
                  <input
                    i18n-placeholder
                    placeholder="Type"
                    [formControl]="product.controls.type"
                    id="type"
                    type="text"
                    pInputText />
                </div>
                <div class="layout--full-width">
                  <input
                    [thousandSeparator]="isFr ? ' ' : ','"
                    [prefix]="product.controls.amount.value && !isFr ? '$' : ''"
                    [suffix]="isFr ? ' $' : ''"
                    mask="separator.2"
                    i18n-placeholder
                    placeholder="Capital Assuré"
                    [formControl]="product.controls.amount"
                    id="amount"
                    type="text"
                    pInputText />
                </div>
                <div class="layout--full-width">
                  <input
                    [thousandSeparator]="isFr ? ' ' : ','"
                    [prefix]="product.controls.price.value && !isFr ? '$' : ''"
                    [suffix]="isFr ? ' $' : ''"
                    mask="separator.2"
                    i18n-placeholder
                    placeholder="Prime"
                    [formControl]="product.controls.price"
                    id="price"
                    type="text"
                    pInputText />
                </div>
                @if (!first || recommendation.controls.products.length > 1) {
                  <button
                    pButton
                    type="button"
                    (click)="removeProduct(i, j)"
                    icon="pi pi-trash"
                    class="p-button-text p-button-plain"></button>
                }
              </div>
              <div class="layout--full-width margin--bottom-medium">
                <textarea
                  [autoResize]="true"
                  style="width: 100%"
                  rows="3"
                  pInputTextarea
                  [formControl]="product.controls.reason"
                  i18n-placeholder
                  placeholder="Raison"></textarea>
              </div>
            </form>
          }
          <p-button
            class="margin--top-medium flex justify-content-end"
            (onClick)="addProduct(i)"
            i18n-label
            label="Ajouter un produit"
            icon="pi pi-plus"></p-button>
        </div>
        <div class="layout--gap margin--bottom-medium">
          <div class="layout--full-width">
            <label class="label-top" i18n>Raison</label>
            <input
              i18n-placeholder
              placeholder="Raison"
              [formControl]="recommendation.controls.reason"
              id="reason"
              type="text"
              pInputText />
          </div>
        </div>
        <div class="flex justify-content-end align-items-center gap-2">
          <p-checkbox [formControl]="recommendation.controls.isRecommended" [binary]="true"></p-checkbox>
          <label class="mb-0" i18n>Recommandé</label>
          @if (!first || recommendationsForm.controls.length > 1) {
            <button
              pButton
              type="button"
              (click)="removeRecommandationSection(i)"
              icon="pi pi-trash"
              class="p-button-text p-button-plain"></button>
          }
        </div>
      </div>
    </form>
  }

  <p-button
    class="margin--top-medium flex justify-content-end"
    (onClick)="addRecommendation()"
    i18n-label
    label="Ajouter une recommandation"
    icon="pi pi-plus"></p-button>
</p-card>
